import classes from "./PaymentProcessing.module.scss";
import React, { useContext, useEffect, useState } from "react";
import afinandinhoCreditCard from "./../../../../../../assets/images/afinandinho_credit_card.svg";
import paymentValue from "./../../../../../../assets/images/price_tag.svg";
// import paymentCalendar from "./../../../../../../assets/images/payment_calendar_secondary.svg";
import paymentCreditCard from "./../../../../../../assets/images/credit_cardIcon_seconday.svg";
import paymentHourglass from "./../../../../../../assets/images/payment_hourglass_secondary.svg";
import payment_hourglass_purple from "./../../../../../../assets/images/payment_hourglass_purple.svg";
import afinandinhoDefault from "./../../../../../../assets/images/afinandinho_plano_default.svg";
import spinnerPurple from "./../../../../../../assets/images/spinner_purple.gif";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import SystemContext from "../../../../../../context/SystemContext";

const PaymentProcessing = () => {
  const payload = useSelector((state) => state.purchase);
  const { t } = useTranslation();
  const [content, setContent] = useState(null);
  const { changePropertyUrl } = useContext(SystemContext);

  useEffect(() => {
      changePropertyUrl("",{etapa:"processando"});
  }, []);

  useEffect(() => {
    if (payload && payload.planInfo) {
      setContent((
        <div className={classes.PaymentProcessingContent}>
          <div className={classes.Title}>
            <img className={classes.Image} src={payment_hourglass_purple} alt="" />
            {t("purchase.we_are_processing_your_payment")}
          </div>
          <div className={classes.CardText}>
            <div className={classes.TextOne}>
              {t("purchase.your_purchase_has_been_registered")}
            </div>
            <div className={classes.TextTwo}>
              {t("purchase.your_payment_is_being_processed")}{" "}
            </div>
            <div className={classes.TextThree}>
              {t(
                "purchase.if_approved_you_will_receive_a_copy_of_the_invoice_in_your_email"
              )}
            </div>
            <img className={classes.Image} src={afinandinhoCreditCard} alt="" />
          </div>
          <div className={classes.CardInfoPayment}>
            <div className={classes.ItemPurchased}>
              <img
                className={classes.Image}
                src={afinandinhoDefault}
                alt="planName"
              />
              <div className={classes.ItemName}>
                {payload.planInfo.planName}
              </div>
            </div>
            <div className={classes.Info}>
              <div className={classes.PaymentMethod}>
                <img
                  className={classes.Image}
                  src={paymentCreditCard}
                  alt="paymentMethod"
                />
                <div>{t("purchase.payment")}</div>{" "}
                <b>{t(`purchase.${payload.planInfo?.payment_method?.replace("creditcard", "credit_card")}`)}</b>
              </div>
              <div className={classes.NextPayment}>
                <img
                  className={classes.Image}
                  src={paymentValue}
                  alt="totalPlan"
                />{" "}
                <div>{t("purchase.total_value")}</div>
                <b>{payload.planInfo.value}</b>
              </div>
              <div className={classes.Recurrence}>
                <img
                  className={classes.Image}
                  src={paymentHourglass}
                  alt="paymentCalendar"
                />
                <div> {t("purchase.frequency")} </div>
                <b> {t(`purchase.${payload.planInfo?.periodicity}`)}</b>
              </div>
            </div>
            <img
              className={classes.Spinner}
              src={spinnerPurple}
              alt="paymentCalendar"
            />
          </div>
        </div>
      ));
    }
  }, [payload])
  return content
};
export default PaymentProcessing;
